<template>
  <v-row justify="center">
    <v-dialog v-model="TransferDialog" persistent max-width="500">
      <template v-slot:activator="{ on, attrs }">
        <div
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          @click="clsoe()"
        >
          <v-card
            flat
                class="mx-auto cardTr bg"
                max-width="250"
            >
                <img src="../assets/bank.png" alt="teller logo" width="40" height="40">
                <div class="init">
                    <h5>Bank Transfer</h5>
                    <small>Transfer money to any bank account</small> 
                </div>
            </v-card>
        </div>
      </template>
        <v-card v-if="TransferDialogSuccess" class="padd">
         <div>
              <v-card-title>
              <b><span class="headline">Confirm</span></b>
            </v-card-title>
          <v-container>
                <hr/>
              <v-row>
                 <v-col cols="12" sm="4">
                 <p><b>Account Number</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{AccountNumber}}</p>
                </v-col>
                    <v-col cols="12" sm="4">
                 <p><b>Account Name</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{holderName}}</p>
                </v-col>
                    <v-col cols="12" sm="4">
                 <p><b>Amount</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{DisplayCurrency(amount)}}</p>
                </v-col>
              </v-row>
                   <hr/>
          </v-container>
          <small>*Teller</small>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn text large @click="clsoesuccess()">Close</v-btn>
          <v-btn dark color="pink" @click="ConfirmPayment()">Proceed</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
         </div>
        </v-card>

      <v-card v-else class="padd">
         <div>
          <v-container>
              <h4 class="bankT">Bank Transfer</h4>
              <v-row>
                <v-col cols="12" sm="12">
                  <div class="labelDiv">
                      <label>Select account to withdraw from </label>
                    </div>
                  <v-select
                    v-model="withdrawAccountType"
                    item-text="label"
                    :items="wallet"
                    solo
                    append-icon="mdi-menu-down"
                    >
                    </v-select>
                    <div class="labelDiv">
                      <label>Select Bank</label>
                    </div>
                  <v-select
                    v-model="bankcode"
                     item-text="label"
                    :items="banks"
                       append-icon="mdi-menu-down"
                    solo
                    >
                    </v-select>
                    <div class="labelDiv">
                      <label>Account number </label>
                    </div>
                <v-text-field
                    type='number'
                    class="fieldtx"
                     v-model="AccountNumber"
                    outlined
                    dense
                  ></v-text-field>
                    <div class="labelDiv">
                      <label>Amount</label>
                    </div>
                <v-text-field
                    type='number'
                    class="fieldtx"
                    v-model="amount"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
      </v-container>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text large @click="clsoe(true)">Close</v-btn>
          <v-btn dark class="btn" large @click="verifyAccount()">Proceed</v-btn>
        <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import currencyFormatter from 'currency-formatter'

  export default {
    computed: {
       User () {
        return this.$store.getters.getUser
        },
        holderName () {
        return this.$store.getters.getholderName
        },
        TransferDialog () {
        return this.$store.getters.getTransferDialog
        },
        TransferDialogSuccess () {
        return this.$store.getters.getTransferDialogSuccess
        },
    },
    methods: {
        DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN"
      });
    },
      clsoe(payload){

        if(payload){
            this.bankcode='',
            this.withdrawAccountType='',
            this.AccountNumber="",
            this.amount=""
        }
          this.$store.commit('setTransferDialog', !this.TransferDialog)
      },
      clsoesuccess(){
          this.$store.commit('setTransferDialogSuccess', false)
      },
      ConfirmPayment(){
               if (this.AccountNumber == "" || this.bankcode == "" || this.withdrawAccountType == "" || this.amount == ""){
                  let payload = {
                  status: true,
                  message:"Fill out all the required fields"
                  }
                    this.$store.dispatch('SnackbarFunc', payload)
                    return;
                   }
                   let payload = {
                    bankcode: this.bankcode,
                    AccountNumber:this.AccountNumber,
                    withdrawAccountType:this.withdrawAccountType,
                    amount:this.amount,
                    customerID:this.User.customerID,
                    pin:this.User.pin,
                    route: this.$router
                    }
                    this.$store.dispatch('ConfirmPayment', payload)


      },
      verifyAccount(){
         if (
      this.AccountNumber == "" ||
      this.bankcode == "" ||
      this.withdrawAccountType == "" ||
      this.amount == ""
    ) 
    {
        let payload = {
                status: true,
                message:"Fill out all the required fields"
            }
        this.$store.dispatch('SnackbarFunc', payload)
      return;
    }
     let payload = {
                bankcode: this.bankcode,
                AccountNumber:this.AccountNumber
            }
    this.$store.dispatch('verifyAccount', payload)
      }
    },
    data () {
      return {
        dialog: false,
        bankcode:'',
        withdrawAccountType:'',
        AccountNumber:"",
        amount:"",
      wallet:  [
    {
      label: "Main Account",
      value: "MAIN"
    },
    {
      label: "COMMISSION Account",
      value: "COMMISSION"
    }
  ],
  banks: [
  {
    label: "Sterling Bank",
    value: "000001"
  },
  {
    label: "Keystone Bank",
    value: "000002"
  },
  {
    label: "First City Monument Bank",
    value: "000003"
  },
  {
    label: "United Bank for Africa",
    value: "000004"
  },
  {
    label: "Access Bank (Diamond)",
    value: "000005"
  },
  {
    label: "JAIZ Bank",
    value: "000006"
  },
  {
    label: "Fidelity Bank",
    value: "000007"
  },
  {
    label: "Skye Bank",
    value: "000008"
  },
  {
    label: "Citi Bank",
    value: "000009"
  },
  {
    label: "Ecobank Bank",
    value: "000010"
  },
  {
    label: "Unity Bank",
    value: "000011"
  },
  {
    label: "StanbicIBTC Bank",
    value: "000012"
  },
  {
    label: "GTBank Plc",
    value: "000013"
  },
  {
    label: "Access Bank",
    value: "000014"
  },
  {
    label: "Zenith Bank Plc",
    value: "000015"
  },
  {
    label: "First Bank of Nigeria",
    value: "000016"
  },
  {
    label: "Wema Bank",
    value: "000017"
  },
  {
    label: "Union Bank",
    value: "000018"
  },
  {
    label: "Enterprise Bank",
    value: "000019"
  },
  {
    label: "Heritage Bank",
    value: "000020"
  },
  {
    label: "Standard Chartered",
    value: "000021"
  },
  {
    label: "Suntrust Bank",
    value: "000022"
  },
  {
    label: "Providus Bank",
    value: "000023"
  }
],

      }
    },
  }
</script>
<style scoped>
.cardTr{
    display: flex;
    align-items: center;
    padding: 15px;
    padding-right: 20px;
    padding-left: 20px;
    height: 100px;
    border-radius: 20px !important;
    margin-right: 20px;
    margin-left: 20px;
    margin-bottom: 20px;
    cursor: pointer;
}
.bg{
    background-color: rgba(235, 87, 87, 0.2);
}
.init{
    margin-left: 15px;
}
.padd{
    padding: 10px;
    border-radius: 10px;
}
.bankT{
    text-align: center;
    color: #ad1684;

}
.btn{
    background-color: #ad1684 !important;
    text-transform: none;
}
@media only screen and (max-width: 700px) {
  .cardTr{
    display: flex;
    align-items: center;
    padding: 5px;
    padding-right: 10px;
    padding-left: 10px;
    height: 100px;
    border-radius: 20px !important;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
    cursor: pointer;
}
}
</style>